"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjudicationReviewOutputSchema = exports.SignalDecisionDraftSchema = exports.SignalDispositionKind = exports.ErrorDecisionDraftSchema = exports.GroundTruthDecisionDraftSchema = exports.AdjudicationReviewInputSchema = void 0;
exports.isGroundTruthRuled = isGroundTruthRuled;
exports.isErrorRuled = isErrorRuled;
exports.rowsRuledAbsent = rowsRuledAbsent;
exports.absentRowReasons = absentRowReasons;
const z = require("zod");
const consensus_types_1 = require("../../../../Consensus/consensus.types");
const property_key_1 = require("../../../../Consensus/property-key");
const slice_key_1 = require("../../../../Consensus/slice-key");
const package_data_adjudication_types_1 = require("../../../../PackageDataAdjudication/package-data-adjudication.types");
const json_value_1 = require("../../../../Utils/json-value");
const adjudication_view_types_1 = require("./adjudication-view.types");
exports.AdjudicationReviewInputSchema = z.object({
    requestId: z.string(),
    packageId: z.string(),
    sliceKey: slice_key_1.SliceKeySchema,
    sliceVersion: z.number().int(),
    sigmaModelType: z.string(),
    propertyKey: property_key_1.PropertyKeySchema,
    resolutionEntryId: z.string(),
    context: adjudication_view_types_1.AdjudicationContextSchema,
    rows: adjudication_view_types_1.AdjudicationRowSchema.array(),
    standings: adjudication_view_types_1.AnchorStandingSchema.array(),
    contested: adjudication_view_types_1.ContestedValueSchema.array(),
    roster: adjudication_view_types_1.RosterSignalSchema.array().default([]),
});
exports.GroundTruthDecisionDraftSchema = z.object({
    anchor: consensus_types_1.AnchorSchema,
    rawValue: json_value_1.JsonValueSchema.optional(),
    existence: package_data_adjudication_types_1.RowExistenceSchema.optional(),
    clauses: package_data_adjudication_types_1.ClauseCitationsSchema.optional(),
    comment: z.string().nullable().optional(),
});
function isGroundTruthRuled(decision) {
    return decision !== undefined && (decision.rawValue !== undefined || decision.existence !== undefined);
}
exports.ErrorDecisionDraftSchema = z.object({
    anchor: consensus_types_1.AnchorSchema,
    rawValue: json_value_1.JsonValueSchema.nullable(),
    clauses: package_data_adjudication_types_1.ClauseCitationsSchema.optional(),
    errorCodeIds: z.string().array().optional(),
    comment: z.string().nullable().optional(),
});
function isErrorRuled(decision) {
    return decision !== undefined && (decision.clauses?.length ?? 0) > 0;
}
function rowsRuledAbsent(output) {
    return new Set(output.groundTruthDecisions.flatMap((decision) => decision.anchor.kind === consensus_types_1.AnchorKind.Row && decision.existence === package_data_adjudication_types_1.RowExistence.Absent ?
        [decision.anchor.rowKey]
        : []));
}
function absentRowReasons(output) {
    const absent = rowsRuledAbsent(output);
    const reasons = new Map();
    for (const decision of output.errorDecisions) {
        if (decision.anchor.kind === consensus_types_1.AnchorKind.Row && absent.has(decision.anchor.rowKey) && isErrorRuled(decision)) {
            reasons.set(decision.anchor.rowKey, decision);
        }
    }
    return reasons;
}
var SignalDispositionKind;
(function (SignalDispositionKind) {
    SignalDispositionKind["Rename"] = "rename";
    SignalDispositionKind["Create"] = "create";
    SignalDispositionKind["Delete"] = "delete";
})(SignalDispositionKind || (exports.SignalDispositionKind = SignalDispositionKind = {}));
exports.SignalDecisionDraftSchema = z.object({
    kind: z.nativeEnum(SignalDispositionKind),
    name: z.string().optional(),
    signalId: z.string().optional(),
    clauses: package_data_adjudication_types_1.ClauseCitationsSchema.optional(),
    errorCodeIds: z.string().array().optional(),
    comment: z.string().nullable().optional(),
});
exports.AdjudicationReviewOutputSchema = z.object({
    groundTruthDecisions: exports.GroundTruthDecisionDraftSchema.array().default([]),
    errorDecisions: exports.ErrorDecisionDraftSchema.array().default([]),
    signalDecisions: exports.SignalDecisionDraftSchema.array().default([]),
});
//# sourceMappingURL=adjudication-step.types.js.map